var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SubscriptionPricing',{attrs:{"config":_vm.pricingConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }